const Icon = ({ name }) => {
  return <i className="material-symbols-outlined">{name}</i>;
};

export default Icon;
